module.exports = __webpack_public_path__ + "static/img/immiexperts.51f00a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/immiexperts.png
// module id = 35
// module chunks = 1